import { c as _c } from "react/compiler-runtime";
import { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import useSWR from 'swr';
import { OutpostEvent } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import { formatDate } from '../../../../utils/date';
import Button from '../../../common/base/Button';
import Chip from '../../../common/base/Chip';
import Divider from '../../../common/base/Divider';
import Loading from '../../../common/base/Loading';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import { MetadataGrid } from '../../../common/MetadataGrid';
import { GlobalContext } from '../../../contexts/GlobalContext';
import useLocalStorage from '../../../hooks/useLocalStorage';
import { useDatePreferences } from '../../../hooks/useDatePreferences';
import { StyledViewNavHeader, StyledViewNavSecondary, StyledViewSidebar, StyledViewSidebarActions, StyledViewSidebarFooter, StyledViewSidebarNav, StyledViewSidebarScrollableSection, ViewSidebarTitle } from '../../../layouts/ViewLayout';
import { OutpostDataCollapsibleSection } from '../Event/OutpostDataSection';
import { OutpostMetadataCollapsibleSection } from '../Event/OutpostMetadataSection';
import { getOutpostTenantLabel, useOutpostTenantsById } from '../utils/tenantDisplay';
const EventSidebar: React.FC<{
  event_id: string;
  list_event?: OutpostEvent;
  onClose: () => void;
  onPrev?: () => void;
  onNext?: () => void;
}> = t0 => {
  const $ = _c(68);
  const {
    event_id,
    list_event,
    onClose,
    onPrev,
    onNext
  } = t0;
  const {
    timezone
  } = useDatePreferences();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    pathname
  } = useLocation();
  const [active_tab, setActiveTab] = useLocalStorage("prefs:outpost:event:active-tab", "request");
  let t1;
  if ($[0] !== event_id) {
    t1 = APIMethodKeys.outpost.events.get(event_id);
    $[0] = event_id;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== HookdeckAPI.outpost.events || $[3] !== event_id) {
    t2 = () => HookdeckAPI.outpost.events.get(event_id);
    $[2] = HookdeckAPI.outpost.events;
    $[3] = event_id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    data: fetched_event
  } = useSWR(t1, t2);
  let t3;
  let t4;
  if ($[5] !== onClose || $[6] !== onNext || $[7] !== onPrev) {
    t3 = () => {
      const handle_keydown = e => {
        if (e.key === "ArrowUp" && onPrev) {
          e.preventDefault();
          onPrev();
        } else {
          if (e.key === "ArrowDown" && onNext) {
            e.preventDefault();
            onNext();
          } else {
            if (e.key === "Escape") {
              e.preventDefault();
              onClose();
            }
          }
        }
      };
      window.addEventListener("keydown", handle_keydown);
      return () => window.removeEventListener("keydown", handle_keydown);
    };
    t4 = [onPrev, onNext, onClose];
    $[5] = onClose;
    $[6] = onNext;
    $[7] = onPrev;
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  const event = fetched_event || list_event;
  const t5 = event?.tenant_id;
  let t6;
  if ($[10] !== t5) {
    t6 = [t5];
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const {
    tenants_by_id
  } = useOutpostTenantsById(t6);
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      align: "center",
      gap: 2
    };
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== event_id) {
    t8 = <Div flex={t7}><ViewSidebarTitle title={event_id} /></Div>;
    $[13] = event_id;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== event_id || $[16] !== pathname) {
    t9 = !pathname.includes(`/events/${event_id}`) && <Button ghost={true} icon="open" to={`/events/${event_id}`} />;
    $[15] = event_id;
    $[16] = pathname;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onClose) {
    t10 = <Button ghost={true} icon="close" onClick={onClose} />;
    $[18] = onClose;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <StyledViewSidebarActions>{t9}{t10}</StyledViewSidebarActions>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t8) {
    t12 = <StyledViewNavHeader>{t8}{t11}</StyledViewNavHeader>;
    $[23] = t11;
    $[24] = t8;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const nav_header = t12;
  if (!event) {
    let t13;
    if ($[26] !== nav_header) {
      t13 = <StyledViewSidebarNav>{nav_header}</StyledViewSidebarNav>;
      $[26] = nav_header;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    let t14;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <Div flex={{
        grow: true,
        align: "center",
        justify: "center"
      }}><Loading /></Div>;
      $[28] = t14;
    } else {
      t14 = $[28];
    }
    let t15;
    if ($[29] !== t13) {
      t15 = <StyledViewSidebar>{t13}{t14}</StyledViewSidebar>;
      $[29] = t13;
      $[30] = t15;
    } else {
      t15 = $[30];
    }
    return t15;
  }
  let t13;
  if ($[31] !== event.metadata) {
    t13 = event.metadata ? Object.fromEntries(Object.entries(event.metadata).map(_temp)) : {};
    $[31] = event.metadata;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  const metadata_as_strings = t13;
  let t14;
  if ($[33] !== metadata_as_strings) {
    t14 = Object.keys(metadata_as_strings);
    $[33] = metadata_as_strings;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const has_metadata = t14.length > 0;
  let t15;
  if ($[35] !== setActiveTab) {
    t15 = tab => setActiveTab(tab);
    $[35] = setActiveTab;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = [{
      key: "request",
      label: "Request"
    }, {
      key: "details",
      label: "Details"
    }];
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== active_tab || $[39] !== t15) {
    t17 = <StyledViewNavSecondary><Tabs active_tab={active_tab} border={false} onTabSelected={t15} tabs={t16} /></StyledViewNavSecondary>;
    $[38] = active_tab;
    $[39] = t15;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== nav_header || $[42] !== t17) {
    t18 = <StyledViewSidebarNav>{nav_header}{t17}</StyledViewSidebarNav>;
    $[41] = nav_header;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== active_tab || $[45] !== event.data || $[46] !== has_metadata || $[47] !== metadata_as_strings) {
    t19 = active_tab === "request" && <Div>{has_metadata && <OutpostMetadataCollapsibleSection metadata={metadata_as_strings} embedded={true} context_menu={true} context_menu_config={{
        table_column_prefix: "metadata"
      }} />}<OutpostDataCollapsibleSection data={event.data} embedded={true} collapsible={has_metadata} default_collapsed={false} collapsed_storage_key="prefs:outpost:event-sidebar:data:collapsed" context_menu={true} context_menu_config={{
        table_column_prefix: "data"
      }} /></Div>;
    $[44] = active_tab;
    $[45] = event.data;
    $[46] = has_metadata;
    $[47] = metadata_as_strings;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== active_tab || $[50] !== event.destination_id || $[51] !== event.successful_at || $[52] !== event.tenant_id || $[53] !== event.time || $[54] !== event.topic || $[55] !== tenants_by_id || $[56] !== timezone) {
    t20 = active_tab === "details" && <Div p={{
      x: 6,
      b: 8
    }}><MetadataGrid embedded={true}><Text muted={true} ellipsis={true}>Topic</Text><Text mono={true} size="s" ellipsis={true}>{event.topic}</Text></MetadataGrid><Divider /><MetadataGrid embedded={true}><Text muted={true} ellipsis={true}>Time</Text><Text mono={true} size="s" ellipsis={true}>{formatDate(event.time, "MMM d HH:mm:ss", timezone).toUpperCase()}</Text></MetadataGrid><Divider /><MetadataGrid embedded={true}><Text muted={true} ellipsis={true}>Successful at</Text><Text mono={true} size="s" ellipsis={true} muted={!event.successful_at}>{event.successful_at ? formatDate(event.successful_at, "MMM d HH:mm:ss", timezone).toUpperCase() : "\u2014"}</Text></MetadataGrid><Divider /><MetadataGrid embedded={true}><Text muted={true} ellipsis={true}>Tenant</Text><Div><Chip outline={true} label={getOutpostTenantLabel(event.tenant_id, tenants_by_id[event.tenant_id])} to={`/tenants/${event.tenant_id}`} /></Div></MetadataGrid>{event.destination_id && <><Divider /><MetadataGrid embedded={true}><Text muted={true} ellipsis={true}>Destination</Text><Div><Chip mono={true} outline={true} label={event.destination_id} to={`/tenants/${event.tenant_id}/destinations/${event.destination_id}`} /></Div></MetadataGrid></>}</Div>;
    $[49] = active_tab;
    $[50] = event.destination_id;
    $[51] = event.successful_at;
    $[52] = event.tenant_id;
    $[53] = event.time;
    $[54] = event.topic;
    $[55] = tenants_by_id;
    $[56] = timezone;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  let t21;
  if ($[58] !== t19 || $[59] !== t20) {
    t21 = <StyledViewSidebarScrollableSection>{t19}{t20}</StyledViewSidebarScrollableSection>;
    $[58] = t19;
    $[59] = t20;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] !== onNext || $[62] !== onPrev) {
    t22 = (onPrev || onNext) && <StyledViewSidebarFooter><Div w={100} flex={{
        align: "center",
        gap: 2,
        justify: "flex-end"
      }}><Button outline={true} icon="chevron_up" onClick={onPrev} /><Button outline={true} icon="chevron_down" onClick={onNext} /></Div></StyledViewSidebarFooter>;
    $[61] = onNext;
    $[62] = onPrev;
    $[63] = t22;
  } else {
    t22 = $[63];
  }
  let t23;
  if ($[64] !== t18 || $[65] !== t21 || $[66] !== t22) {
    t23 = <StyledViewSidebar>{t18}{t21}{t22}</StyledViewSidebar>;
    $[64] = t18;
    $[65] = t21;
    $[66] = t22;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  return t23;
};
export default EventSidebar;
function _temp(t0) {
  const [key, value] = t0;
  return [key, typeof value === "object" ? JSON.stringify(value) : String(value ?? "")];
}